import React, { useState } from "react";
import { useRef, useEffect } from "react";

export default function App() {
  const [items, setItems] = useState([]);
  function handleAddItems(item) {
    setItems((items) => [...items, item]);
  }
  function handleRemoveItem(id) {
    setItems((items) => items.filter((item) => item.id !== id));
  }
  function handleClearAll() {
    setItems([]);
  }

  return (
    <div className="app">
      <Logo />
      <Form onAddItem={handleAddItems} onClearAll={handleClearAll} />
      <PackingList items={items} onRemoveItem={handleRemoveItem} />

      <Status items={items} />
    </div>
  );
}

function Logo() {
  return <h1>🌴 Far Away 🪹</h1>;
}

function Form({ onAddItem, onClearAll }) {
  const [description, setDescription] = useState("");
  const [quantity, setQuantity] = useState(1);
  const inputRef = useRef(null);

  useEffect(() => {
    function handleKeyPress(event) {
      if (event.key === "Enter" && !event.target.tagName === "TEXTAREA") {
        event.preventDefault(); // Prevent form submission
        inputRef.current.focus(); // Focus the input field
      }
    }
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  function handleSubmit(e) {
    e.preventDefault();
    if (!description) return;
    const newItem = { description, quantity, packed: false, id: Date.now() };
    console.log(newItem);

    onAddItem(newItem);
    setDescription("");
    setQuantity(1);
  }
  function handleMouseEnter() {
    inputRef.current.focus();
  }

  return (
    <form
      className="add-form"
      onSubmit={handleSubmit}
      onMouseEnter={handleMouseEnter}
    >
      <h3>What do you need for your trip</h3>
      <select
        value={quantity}
        onChange={(e) => setQuantity(Number(e.target.value))}
        ref={inputRef}
      >
        {Array.from({ length: 20 }, (_, i) => i + 1).map((num) => (
          <option value={num} key={num}>
            {num}
          </option>
        ))}
      </select>
      <input
        type="text"
        placeholder="Item..."
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      ></input>
      <button type="submit">Add</button>
      <button type="button" onClick={onClearAll} className="clear-btn">
        Clear All
      </button>
    </form>
  );
}

function PackingList({ items, onRemoveItem, onClearAll }) {
  return (
    <div className="list">
      <ul>
        {items.map((item) => (
          <Item item={item} key={item.id} onRemove={onRemoveItem} />
        ))}
      </ul>
    </div>
  );
}

function Item({ item, onRemove }) {
  return (
    <li>
      <span style={item.packed ? { textDecoration: "line-through" } : {}}>
        {item.description} - {item.quantity}
      </span>
      <button onClick={() => onRemove(item.id)}>❌</button>
    </li>
  );
}

function Status({ items }) {
  const packedItems = items.filter((item) => item.packed).length;
  const totalItems = items.length;
  const packedPercentage =
    totalItems === 0 ? 0 : Math.round((packedItems / totalItems) * 100);

  return (
    <footer className="stats">
      <em>
        🪸 You have {totalItems} items on your list, and you already packed{" "}
        {packedItems} ({packedPercentage}%)
      </em>
    </footer>
  );
}
